var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isHolding)?_c('div',{staticClass:"escape-hold-indicator",style:({ '--escape-hold-duration': `${_vm.holdDuration}ms` }),attrs:{"role":"status","aria-label":"Håll Escape för att byta användare"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"escape-hold-indicator__track"},[_c('div',{staticClass:"escape-hold-indicator__progress"})])
}]

export { render, staticRenderFns }